var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('router-view',{key:_vm.$route.path}),_c('portal-target',{attrs:{"name":"modal","multiple":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }